var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoConformeDaValidare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.75C5.16751 18.75 1.25 14.8325 1.25 10C1.25 5.16751 5.16751 1.25 10 1.25C14.8325 1.25 18.75 5.16751 18.75 10C18.75 14.8325 14.8325 18.75 10 18.75ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#008055"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7121 6.21209C13.7032 6.22093 13.6949 6.23029 13.6872 6.24013L9.34674 11.7709L6.72985 9.15403C6.36373 8.78791 5.77014 8.78791 5.40402 9.15403C5.0379 9.52015 5.0379 10.1137 5.40402 10.4799L8.71208 13.7879C9.0782 14.154 9.67179 14.154 10.0379 13.7879C10.0461 13.7798 10.0538 13.7712 10.061 13.7622L15.0512 7.52434C15.404 7.15727 15.3995 6.57371 15.0379 6.21209C14.6718 5.84597 14.0782 5.84597 13.7121 6.21209Z",
    fill: "#008055"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoConformeDaValidare);
export default __webpack_public_path__ + "static/media/ico-conforme-da_validare.5da702c5e8c28e81f8cba114c3b811ad.svg";
export { ForwardRef as ReactComponent };